<template>
  <div class="orderManagement-view">
    <el-tabs v-model="activeName"  @tab-click="handleClick">
      <el-tab-pane :label="$t('order', 'orderList')" name="first">
        <orderList v-if="activeName == 'first'" />
      </el-tab-pane>
      <el-tab-pane :label="$t('order', 'afterSale')" name="second">
        <afterSale v-if="activeName == 'second'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import orderList from "./components/orderList";
import afterSale from "./components/afterSale";
import i18nMixin from '@/mixins/i18nMixin';
export default {
  name: "orderManagement",
  mixins: [i18nMixin],
  components: {
    orderList,
    afterSale,
  },
  data() {
    return {
      activeName: "first",
    };
  },
  methods: {
    handleClick(tab) {
      const { name } = tab;
      this.activeName = name;
    },
  },
};
</script>

<style scoped lang='sass'>
</style>